/**
 * Video yerleşim modu.
 *
 * İki mod vardır ve ikisi de kullanıcı seçimidir:
 *
 *   - `contain` (Sığdır) → görüntünün tamamı görünür; 16:9 dışı içerikte
 *     siyah bant kalabilir. **Varsayılan ve görüntü kaybı olmayan mod.**
 *   - `cover` (Doldur) → kutu/screen tamamen dolar; kenarlar kırpılır.
 *
 * Tercih cihazda saklanır: telefonda doldur, masaüstünde sığdır seçmek
 * makuldür. Sunucuya gönderilmez.
 */
import { useCallback, useState } from 'react';

export type VideoFit = 'contain' | 'cover';

const STORAGE_KEY = 'pbfork.videoFit.v1';

export function sanitizeVideoFit(value: unknown): VideoFit {
  return value === 'cover' ? 'cover' : 'contain';
}

export function nextVideoFit(fit: VideoFit): VideoFit {
  return fit === 'contain' ? 'cover' : 'contain';
}

export function readVideoFit(): VideoFit {
  if (typeof localStorage === 'undefined') return 'contain';
  try {
    return sanitizeVideoFit(localStorage.getItem(STORAGE_KEY));
  } catch {
    return 'contain';
  }
}

export function writeVideoFit(fit: VideoFit): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, fit);
  } catch {
    // Gizli mod / kota: tercih yalnız bu oturumda kalır.
  }
}

export function useVideoFit(): { fit: VideoFit; toggle: () => void } {
  const [fit, setFit] = useState<VideoFit>(readVideoFit);
  const toggle = useCallback(() => {
    setFit((current) => {
      const next = nextVideoFit(current);
      writeVideoFit(next);
      return next;
    });
  }, []);
  return { fit, toggle };
}
